var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.Product = new Class({
    Implements: [Options, Events],
    retrieved: false,
    options: {
        entry_id: '',
        entry_order: '',
        entry_order_ft: '',
        parsed_xml: {},
        product_content: '',
        product_content_ft: '',
        product_description: '',
        product_description_ft: '',
        product_thumbnail: '',
        product_thumbnail_ft: '',
        product_type: '',
        product_type_1: '',
        product_type_1_ft: '',
        short_title: '',
        short_title_ft: '',
        static_map: '',
        static_map_ft: '',
        title: '',
        url_title: '',
    },
    initialize: function (op) {
        this.setOptions(op);
    },
    get_product_content: function () {
        return this.options.product_content;
    },
    get_product_type: function() {
        if(this.options.product_type !== "") {
            return this.options.product_type
        }
        return this.get_product_type_1();
    },    
    get_product_type_1: function() {
        if(this.options.product_type_1 !== "") {
            return this.options.product_type_1
        } 
        if(this.options.product_type !== "") {
            return this.options.product_type;
        }
        return "";
    },
    get_product_title: function() {
        return this.options.title;
    },
    get_entry_id: function() {
        return this.options.entry_id;
    },
    set_product_content: function(cont) {
        this.options.product_content = cont;
    },
    set_retrieved: function(val) {
        this.retrieved = val;
    },
    data: function () {
        return this.options;
    },
    parse_product_content_from_XML: function () {
        if (!Object.keys(this.options.parsed_xml).length) {
            this.options.parsed_xml = $((new DOMParser()).parseFromString(this.get_product_content(), "text/xml"));
        }
        return this.options.parsed_xml;
    },
});